module.exports = __webpack_public_path__ + "static/media/processing.406ceaaa.svg";